import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FormlyFieldConfig, FormlyModule} from '@ngx-formly/core';

import * as _ from 'lodash';
import moment from 'moment';
import {SidenavService} from "../../services/sidenav.service";
import {SettingsService} from "../../services/settings.service";
import {TwoFactorService} from "../../services/two-factor.service";
import {CommonModule} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {OrganizationInterface} from "../../interfaces/organization.interface";


@Component({
  selector: 'sous-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  imports: [
    FormlyModule,
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule,
    MatDatepickerModule,
  ],
  standalone: true
})
export class UserFormComponent implements OnInit {

  @Input() data: any;
  type: any = 'users';
  disabled = false;

  filialData: any;
  positionData: any;
  configInfo: any = {};

  form = new FormGroup({});
  model: any = {};

  fields: FormlyFieldConfig[] = [];

  organization: OrganizationInterface | undefined;

  constructor(
    private sidenavService: SidenavService,
    private settingsService: SettingsService,
    private twoFactorService: TwoFactorService,
  ) {
  }


  async ngOnInit(): Promise<void> {
    this.drawFields();
    if (this.data) {
      this.model = this.data;
      this.organization = this.data.organization;
      console.log('-->', this.organization);
      this.model.sex = this.model.sex?.toString();
      const item = _.find(this.configInfo.issue_authority,
        (it) => it.id === this.data.document_issue_authority_id);
      if (item) {
        this.model.document_issue_authority_id = {label: item.name, value: item.id};
      }
    }

  }


  drawFields(): void {
    // @ts-ignore
    this.fields = [
      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'surname',
            type: 'input',
            className: 'w-50 mr8',
            templateOptions: {
              label: $localize`Sure Name`,
              floatingLabel: 'always',
              placeholder: $localize`Enter Sure Name`,
              required: true,
              appearance: 'outline',
            },
          },
          {
            key: 'name',
            type: 'input',
            className: 'w-50 ml8',
            templateOptions: {
              label: $localize`Name`,
              floatingLabel: 'always',
              placeholder: $localize`Enter name`,
              required: true,
              appearance: 'outline',
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'fathers_name',
            type: 'input',
            className: 'w-50 mr8',
            templateOptions: {
              label: $localize`Middle name`,
              floatingLabel: 'always',
              placeholder: $localize`Enter middle name`,
              required: true,
              appearance: 'outline',
            },
          },
          {
            key: 'phone',
            type: 'input',
            className: 'w-50 ml8',
            templateOptions: {
              label: $localize`Phone`,
              floatingLabel: 'always',
              placeholder: $localize`Enter phone`,
              required: true,
              appearance: 'outline',
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'birthdate',
            type: 'datepicker',
            className: 'w-50 mr8',
            templateOptions: {
              label: $localize`Birth date`,
              floatingLabel: 'always',
              placeholder: $localize`Enter Birth date`,
              required: true,
              appearance: 'outline',
            },
          },
          {
            key: 'passport',
            type: 'input',
            className: 'w-50 ml8',
            templateOptions: {
              label: $localize`Passport`,
              floatingLabel: 'always',
              placeholder: $localize`Enter passport`,
              required: true,
              appearance: 'outline',
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'inn',
            type: 'input',
            className: 'w-50 mr8',
            templateOptions: {
              label: $localize`INN`,
              floatingLabel: 'always',
              placeholder: $localize`INN`,
              required: true,
              appearance: 'outline',
            },
          },
          {
            key: 'document_issue_date',
            type: 'datepicker',
            className: 'w-50 ml8',
            templateOptions: {
              label: $localize`passport date create`,
              floatingLabel: 'always',
              placeholder: $localize`YYYY-MM-DD`,
              required: true,
              appearance: 'outline',
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'sex',
            type: 'radio',
            className: 'w-50 mr8 py0',
            templateOptions: {
              label: $localize`Sex`,
              required: true,
              options: [
                {value: '1', label: $localize`Man`},
                {value: '0', label: $localize`Woman`},
              ],
            },
          },
          {
            key: 'document_issue_authority_number',
            type: 'input',
            className: 'w-50 ml8',
            templateOptions: {
              label: $localize`:@@document issue authority number:document issue authority number`,
              floatingLabel: 'always',
              placeholder: $localize`:@@document issue authority number:document issue authority number`,
              required: true,
              maxLength: 4,
              appearance: 'outline',
              type: 'number'
            },
          },
        ],
      },

      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'email',
            type: 'input',
            className: 'w100',
            templateOptions: {
              label: $localize`:@@Email:Email`,
              floatingLabel: 'always',
              placeholder: $localize`:@@Email:Email`,
              required: true,
              appearance: 'outline',
              type: 'string'
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'address',
            type: 'textarea',
            className: 'w100',
            templateOptions: {
              label: $localize`Address`,
              floatingLabel: 'always',
              placeholder: $localize`Enter title`,
              required: true,
              appearance: 'outline',
            },
          },
        ],
      },
      {
        fieldGroupClassName: '',
        fieldGroup: [
          {
            type: 'labels',
            className: 'w100',
            templateOptions: {
              label: $localize`:@@User info:User info`,
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'd-flex w100',
        fieldGroup: [
          {
            key: 'login',
            type: 'input',
            className: 'w-50 mr8',
            templateOptions: {
              label: $localize`Login`,
              floatingLabel: 'always',
              placeholder: $localize`Login`,
              required: true,
              appearance: 'outline',
            },
          },
          {
            key: 'password',
            type: 'input',
            className: 'w-50 ml8',
            templateOptions: {
              label: $localize`Password`,
              floatingLabel: 'always',
              placeholder: $localize`Password`,
              required: false,
              appearance: 'outline',
            },
          },

        ],
      },
    ];
  }


  async create(): Promise<void> {
    this.disabled = true;
    if (!this.organization) {
      return
    }
    const data = this.drawSaveData(this.form.value);
    data.birthdate = moment(data.birthdate, 'DD.MM.YYYY').format('YYYY-MM-DD');
    data.document_issue_date = moment(data.document_issue_date, 'DD.MM.YYYY').format('YYYY-MM-DD');
    data.organizationId = this.organization.id;
    this.settingsService.createUser(data, this.organization.ipAddress, this.organization.license_server_auth_token)
      .subscribe((res: any) => {
        console.log(res);
        if(res.data.error){
          alert(res.data.error.message);
          return
        }
        this.disabled = false;
        this.sidenavService.sideNavState$.next(false);
        this.settingsService.updateList$.next(true);

      })

  }


  drawSaveData(data: any): any {
    const newDate: any = {};
    _.each(data, (item, key) => {
      if (item && typeof item !== 'string' && typeof item !== 'number' && item.value) {
        newDate[key] = item.value;
      } else {
        if (item) {
          newDate[key] = item;
        }

      }
    });
    console.log(newDate);
    return newDate;
  }

  cancel() {
    this.sidenavService.sideNavState$.next(false);
  }

  // Сброс 2FA для пользователя
  drop2fa() {
    if (this.data && this.data.uuid) {
      const userUuid = this.data.uuid;
      this.twoFactorService.drop2fa(userUuid)
        .subscribe((res) => {
          console.log('2FA reset result:', res);
          alert('2FA has been reset for this user');
        }, (error) => {
          console.error('Error resetting 2FA:', error);
          alert('Error resetting 2FA');
        });
    }
  }

}
